import { useGameStore } from '../../store';

export default function DebtModal() {
  const show           = useGameStore((s) => s.showDebtModal);
  const completeDebtAd = useGameStore((s) => s.completeDebtAd);
  const setShow        = useGameStore((s) => s.setShow);

  if (!show) return null;

  return (
    <div className="modal-backdrop center" style={{ display: 'flex' }}>
      <div className="modal-sheet mid">
        <div className="modal-title">💸 빚 변제</div>
        <div className="modal-body" style={{ textAlign: 'center' }}>
          빚을 탕감받고<br />
          <strong style={{ color: 'var(--gold)', fontSize: 18 }}>+1,000만냥</strong>을 지급받으시오.
        </div>
        <button className="modal-btn" onClick={completeDebtAd}>탕감받기</button>
        <button className="modal-btn ghost" onClick={() => setShow('showDebtModal', false)}>
          취소
        </button>
      </div>
    </div>
  );
}
